<script>
  import { ignore } from "../../../Common/tools";

  export let data;
  export let onChange = ignore;
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">When the user visits a page</h4>
  <div class="popup-input-wrapper f-left mt-25">
    <div class="info">
      <h5>What Type of Page?</h5>
    </div>
    <select class="page-select" name="grSelect">
      <option>Website Page</option>
      <option>Funnel Page</option>
    </select>
  </div>
  <div class="popup-input-wrapper f-left">
    <div class="info">
      <h5>What Page Group?</h5>
    </div>
    <select class="page-select" name="grSelect">
      <option>Group Name</option>
    </select>
  </div>
  <div class="popup-input-wrapper f-left">
    <div class="info">
      <h5>What Funnel?</h5>
    </div>
    <select class="page-select" name="grSelect">
      <option>Group Name</option>
    </select>
  </div>
  <div class="popup-input-wrapper f-left">
    <div class="info">
      <h5>What Page?</h5>
    </div>
    <select class="page-select" name="grSelect">
      <option>Page Name</option>
    </select>
  </div>
  <div class="col20 f-left gray-section product-select-wrapper mb-5 none">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">Applied to everyone</h4>
      <a class="text-link blue-text" data-role="changeTextStyles">Change</a>
    </div>
  </div>
</div>
